import {
	createContext,
	Dispatch,
	SetStateAction,
	useContext,
	useDebugValue,
	useEffect,
	useState,
} from 'react';
import { identity } from 'lodash';
import React from 'react';
import { IconName as _ButtonIconName } from '../components/Button';

export type ButtonIconName = _ButtonIconName;

export type StickyHeaderButton = {
	label: string;
	icon?: JSX.Element;
	disabled?: boolean;
	onClick?: () => void;
	loading?: boolean;
	loadingText?: string;
	startIconName?: ButtonIconName;
	endIconName?: ButtonIconName;
	collapsedIconName: ButtonIconName;
};

type StickyHeaderWrapperContextType = Partial<{
	label: string;
	buttons: StickyHeaderButton[];
	maxContentWidth: string;
	showWarningOnLeave: boolean;
	warningOnLeave: string;
	disabled: boolean;
	isLoading: boolean;
}>;

const StickyHeaderWrapperContext = createContext<
	[StickyHeaderWrapperContextType, Dispatch<SetStateAction<StickyHeaderWrapperContextType>>]
>([{}, identity]);

export function StickyHeaderWrapperProvider({ children }: { children: React.ReactNode }) {
	const stickyState = useState<StickyHeaderWrapperContextType>({});

	return (
		<StickyHeaderWrapperContext.Provider value={stickyState}>
			{children}
		</StickyHeaderWrapperContext.Provider>
	);
}

export function useStickyHeaderWrapperProps() {
	const [stickyState] = useContext(StickyHeaderWrapperContext);

	useDebugValue(stickyState);

	return stickyState;
}

export function useStickyHeaderWrapper(props: StickyHeaderWrapperContextType) {
	const [, setStickyState] = useContext(StickyHeaderWrapperContext);

	useEffect(() => {
		setStickyState({
			...props,
		});
	}, [props]);

	// Cleanup function to reset state on unmount
	useEffect(
		() => () => {
			setStickyState({});
		},
		[]
	);
}
